
import { GolfBase } from './Golf-Base';
import { iphoneRedeemCode } from '../../link-actions';

export const GolfHips = () => {
    return (<GolfBase 
                banner={
                    <section className="atf-hero-area atf-shape" style={{padding: "50px 0px", backgroundImage: 'url(./assets/img/smokebg_dark.png)', backgroundColor: '#000000', backgroundSize: 'auto, auto'}}>
                            <div className="container">
                                
                                <div className="row justify-content-center clearfix">
                                    <div className="col-12 text-center align-self-center atf-single-details pt-3">
                                        <h2 style={{ marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa' }}>Turn your hips</h2>
                                    </div>
                                </div>

                                <div className="row justify-content-center clearfix text-center align-self-center">        
                                    <div className="col-lg-4 col-12">
                                        <div className="d-block d-lg-none">
                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Slow motion instant replays</h4>
                                        </div>
                                        <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="d-block d-lg-none">
                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Real-time analysis</h4>
                                        </div>
                                        <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="d-block d-lg-none">
                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Auto pause at key frames</h4>
                                        </div>
                                        <img src="./assets/img/cricket/bowling/test.png" alt="Elbow angle" />
                                    </div>
                                </div>

                    
                                    <div className="row justify-content-center clearfix mt-4">
                                        <div className="text-center align-self-center p-2">
                                            <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                                                <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                                                
                                                <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                                                <a href="#" onClick={() => iphoneRedeemCode("ANALYZER26")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                                    
                                                <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                                                <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 13 Apr 2026</div>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </section>
                }
                />
    
    );
}

export default GolfHips;